module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar py-0 navbar-light justify-content-between flex-nowrap flex-row fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/photo_spot_international_header_logo.png")
    }
  })]), _vm._v(" "), _c('header-right-menu-p-c', {
    attrs: {
      "iconSizeClass": "fa-4x",
      "headerHeight": "70",
      "iconWidth": "85"
    },
    on: {
      "logout": _vm.logout
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fa7f787!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/partials/GuestHeader/PCHeader.vue
// module id = 690
// module chunks = 0